import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Modal, Row, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent, withHandlers, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import { PublisherStatus } from '../../../../constants/publisher';
import { publisherActions } from '../../../../state/modules/publisher';
import { downloadBlobStreamFile, eventHandler, getBlobStream, getCsvStream, writeDataToCsvStream } from '../../../../utils';
import { Icon } from '../../../components';
import CalculatingLoading from '../../calculating-loading';
import { PublisherCreate, PublisherTable } from './partials';

const PublisherDashboard = ({
  activePublishersResult,
  archivedPublishersResult,
  showCreateModal,
  hideCreateModal,
  showingCreateModal,
  exportPublishers
}) => (
    <div className='base-layout'>
      <section className='layout--header'>
        <Grid>
          <Row className='button-gutter'>
            <Col xs={12}>
              <h1>Publisher admin</h1>
            </Col>
          </Row>
        </Grid>
      </section>
      <section className='layout--section'>
        <Grid>
          <section id='publishers--your-caddie-links' className='publishers--dashboard'>
            <Row className='xs-gutter mobile-boxed'>
              <Col xs={12} md={6}>
                <h2><Icon icon='caddie-links-large-alt' /> Publishers</h2>
                <p>Add or manage Publishers.</p>
              </Col>
              <Col xs={12} md={3}>
                <p>
                  <Button className='large full'
                    onClick={exportPublishers}>
                    Export Publishers
                </Button>
                </p>
              </Col>
              <Col xs={12} md={3}>
                <p>
                  <Button className='large full'
                    onClick={eventHandler(showCreateModal)}>
                    <Icon icon='add-large' /> Add Publisher
                </Button>
                </p>
              </Col>
            </Row>
            <Tabs id='admin-tabs'>
              <Tab eventKey='active publisher' title='Active Publishers'>
                <PublisherTable
                  publishersResult={activePublishersResult} />
              </Tab>
              <Tab eventKey='archived publisher' title='Archived Publishers'>
                <PublisherTable
                  publishersResult={archivedPublishersResult} />
              </Tab>
            </Tabs>
          </section>
        </Grid>
      </section>
      <Modal show={showingCreateModal} onHide={hideCreateModal} dialogClassName='create-publisher-model'>
        <Modal.Body>
          <Button onClick={hideCreateModal} className='pull-right full-width' bsStyle='plain'>
            <Icon icon='close' />
          </Button>
          <PublisherCreate />
        </Modal.Body>
      </Modal>
    </div >
  )

const mapStateToProps = (state) => ({
  publishersResult: state.publisher.publisherStats,
  isFetchingPublishers: state.publisher.isFetching,
  industries: state.industry.industries
});

const mapDispatchToProps = (dispatch) => ({
  getPublishers: bindActionCreators(publisherActions.publishers.getStats, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const {
        getPublishers
      } = this.props

      getPublishers()
    }
  }),
  withStateHandlers(({
    showingCreateModal: false
  }), {
      showCreateModal: () => () => ({ showingCreateModal: true }),
      hideCreateModal: () => () => ({ showingCreateModal: false })
    }),
  branch(
    ({ publishersResult, isFetchingPublishers }) => isFetchingPublishers,
    renderComponent(CalculatingLoading)
  ),
  withProps(
    ({ publishersResult }) => ({
      activePublishersResult: fp.filter(
        ({ status }) => status === PublisherStatus.active 
      )(publishersResult),
      archivedPublishersResult: fp.filter(
        ({ status }) => status === PublisherStatus.archived
      )(publishersResult)
    })
  ),
  withHandlers({
    exportPublishers: ({ publishersResult, industries }) => () => {
      const statColumns = [
        'Total Items',
        'Active Items',
        'Total CPD',
        'Active CPD'
      ]
      const sortedIndustries = fp.sortBy('name')(industries)
      const columns = [
        'Name', 'Status', 'Total Items', 'Active Items', 'Total CPD', 'Active CPD'
      ].concat(
        fp.flatMap(
          ({ name }) => fp.map(
            (columnName) => `${columnName} - ${name}`
          )(statColumns)
        )(sortedIndustries)
      )
      const rows = fp.map(
        ({ name, status, totalItemCount, activeItemCount, totalCpd, activeCpd, industryStats }) => [
          name,
          status,
          totalItemCount,
          activeItemCount,
          totalCpd,
          activeCpd
        ].concat(
          fp.flatMap(
            ({ id }) => {
              const industryStat = fp.find(
                ({ industry }) => industry.id === id
              )(industryStats)
              return [
                fp.getOr(0)('totalItemCount')(industryStat),
                fp.getOr(0)('activeItemCount')(industryStat),
                fp.getOr(0)('totalCpd')(industryStat),
                fp.getOr(0)('activeCpd')(industryStat)
              ]
            }
          )(sortedIndustries)
        )
      )(publishersResult)
      downloadBlobStreamFile(writeDataToCsvStream(getCsvStream({
        header: true,
        columns
      }), rows).pipe(getBlobStream()), 'publisher-report.csv')
    }
  })
)(PublisherDashboard)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/publisher-portal/publisher.js